/**
 * Convert Int32 to number
 *
 * @param {import('./Int32Type.js').BrandedInt32} value - Int32 value
 * @returns {number} Number value
 */
export function toNumber(value) {
	return value;
}
